










































import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { SXSurvey, SXQuestion, SXAnswer, SXChoice } from "@/gobl.bundle";

@Component
export default class WSurveyStats extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	loading = false;
	statsError = false;

	get questions() {
		let x = this,
			list = app.services.surveys.surveyQuestions(this.survey);

		return app.services.questions.select(list, function(q) {
			return q.id && q.survey_id === x.survey.id;
		});
	}

	get answers() {
		let x = this;
		return app.services.answers.select(undefined, function(item) {
			return item.id && item.survey_id === x.survey.id;
		});
	}
	get answersTotal() {
		return this.answers.length;
	}
	get answersCounterMessage() {
		let x = this;
		return x.i18n(
			"SX_LANG_ANSWERS_COUNT",
			{ count: x.answersTotal },
			function() {
				return x.answersTotal > 1 ? 1 : 0;
			}
		);
	}

	get stats() {
		let stats: any = this.statsDataTempalteBuilder();

		for (let j = 0; j < this.answers.length; j++) {
			let a = this.answers[j];
			let data = this.ux_custom_data(a.value);
			let userAnswers: { [qid: string]: any } = data.answers;
			let multipleSep = " --- ";

			for (let qid in userAnswers) {
				let questionStats = stats[qid];

				// user may have responded to a deleted question
				if (questionStats) {
					let question = questionStats.question;
					let questionAnswer = userAnswers[qid];
					let qtype = question.type;
					let value = questionAnswer.value || "";
					let othersValue = questionAnswer.othersValue || "";
					let othersChoiceUuid = questionStats.othersChoiceUuid;
					let answerRawText = "";

					questionStats.questionAnswersCount += 1;

					switch (qtype) {
						case "text":
							if (!value.length) {
								questionStats.questionAnswersEmptyCount += 1;
							}
							answerRawText = value;
							break;
						case "bigtext":
							if (!value.length) {
								questionStats.questionAnswersEmptyCount += 1;
							}
							answerRawText = value;
							break;
						case "checkbox":
							if (value.length) {
								let labels: Array<any> = [];

								value.forEach((uuid: string) => {
									if (questionStats.choices[uuid]) {
										questionStats.choices[uuid].count += 1;
										labels.push(
											questionStats.choices[uuid].label
										);
									}
								});

								othersValue && labels.push(othersValue);
								answerRawText = labels.join(multipleSep);
							} else {
								questionStats.questionAnswersEmptyCount += 1;
							}
							break;
						case "radio":
							if (questionStats.choices[value]) {
								if (
									!value ||
									(value === othersChoiceUuid &&
										!othersValue.length)
								) {
									questionStats.questionAnswersEmptyCount += 1;
								} else {
									questionStats.choices[value].count += 1;
									let labels: Array<any> = [];

									labels.push(
										questionStats.choices[value].label
									);

									othersValue && labels.push(othersValue);
									answerRawText = labels.join(multipleSep);
								}
							}
							break;
					}

					questionStats.answersByUsers[a.user_id] = answerRawText;
				}
			}
		}

		return stats;
	}
	statsDataTempalteBuilder() {
		let templates: any = {};

		for (let i = 0; i < this.questions.length; i++) {
			let q = this.questions[i],
				qdata = this.ux_custom_data(q.data),
				qchoices: SXChoice[] = qdata.typeOptions.choices || [],
				othersChoiceEnable = !!qdata.typeOptions.othersChoice,
				othersChoiceUuid = qdata.typeOptions.othersChoiceUuid,
				choicesStats: any = {};

			if (othersChoiceEnable) {
				choicesStats[othersChoiceUuid] = {
					count: 0,
					label: "Autres"
				};
			}

			qchoices.forEach(function(choice) {
				choicesStats[choice.uuid] = {
					count: 0,
					label: choice.label
				};
			});

			templates[q.id] = {
				question: q,
				answerCount: this.answersTotal,
				questionAnswersCount: 0,
				questionAnswersEmptyCount: 0,
				choices: choicesStats,
				othersChoiceUuid,
				answersByUsers: {}
			};
		}
		return templates;
	}

	downloadXLS() {
		let headers = ["Phone"];
		let rows = [headers];
		let stats = this.stats;

		for (let qid in stats) {
			let stat = stats[qid];
			headers.push(stat.question.label);
		}

		for (let j = 0; j < this.answers.length; j++) {
			let uid = this.answers[j].user_id;
			let phone = (
				app.services.users.identify(uid, true) || { phone: "Anonyme" }
			).phone;
			let row = [phone.replace("+229", "")];

			for (let qid in stats) {
				let stat = stats[qid];

				if (stat.answersByUsers[uid] === undefined) {
					row.push("N/A");
				} else {
					row.push(stat.answersByUsers[uid]);
				}
			}

			rows.push(row);
		}

		let content = this.ux_array_to_csv_text(rows);
		let arrayUTF8 = this.ux_to_utf8_array(content);
		let byteNumbers = new Uint8Array(arrayUTF8.length);
		for (let i = 0; i < arrayUTF8.length; i++) {
			byteNumbers[i] = arrayUTF8[i];
		}

		this.ux_download(
			byteNumbers as any,
			`sondxpress-survey-${this.survey.id}.csv`,
			"text/csv;charset=UTF-8;"
		);
	}

	downloadPDF() {
		window.print();
	}

	created() {
		let x = this,
			always = () => (x.loading = false);
		x.loading = true;

		app.services.surveys.getAll(
			{
				filters: {
					[SXSurvey.COL_ID]: x.survey.id
				},
				relations: "all_answers"
			},
			function(response) {
				always();
				let answers =
					(response.data.relations!.all_answers || [])[x.survey.id] ||
					{};

				app.services.answers.addItemsToList(answers);
			},
			function() {
				always();
				x.statsError = true;
			},
			false
		);
	}
}
